<template>
    <main class="form-signin">
        <v-app>
            <div>
                <div class="row ma-4">
                    <v-col cols="12" sm="12" md="6" lg="3" class="mx-auto">
                        <v-card class="mx-auto px-6 py-8" max-width="400">
                            <v-form v-model="form" @submit.prevent="onSubmit">
                                <p class="text-center">
                                    <img :src="require('../../assets/logo.svg')" height="60" />
                                </p>
                                <h2 class="text-center font-weight-medium">Login</h2>
                                <p class="text-center mt-2 mb-0 text-medium-emphasis">
                                    Enter Your Credentials to access your account
                                </p>

                                <v-text-field v-model="form_data.username" :readonly="loading" :rules="[required]"
                                    label="Username" hide-details="auto" class="mb-4" autocomplete="off"
                                    placeholder="Username" variant="outlined" density="compact"></v-text-field>

                                <v-text-field v-model="form_data.password" :readonly="loading" :rules="[required]"
                                    label="Password" placeholder="Enter your password" hide-details="auto" class="mb-4"
                                    autocomplete="off" variant="outlined" density="compact"
                                    :append-inner-icon="show ? 'mdi-eye' : 'mdi-eye-off'" @click:append-inner="show = !show"
                                    :type="show ? 'text' : 'password'"></v-text-field>

                                <v-btn :disabled="!form" :loading="loading" large elevation="0" color="primary" block
                                    type="submit">
                                    Sign In
                                </v-btn>
                            </v-form>
                        </v-card>
                    </v-col>
                </div>
            </div>
        </v-app>
    </main>
</template>
  
<script>
import CryptoJS from "crypto-js";
import AuthService from '@/services/auth.service';
export default {
    data: () => ({
        form_data: {
            username: null,
            password: null,
            encryptedHotspotId:null
        },
        form: false,
        loading: false,
        show: false
    }),
    computed: {
        loggedIn() {
            return this.$store.state.auth.user;
        },
        rules() {
            return ValidationRules;
        },
    },
    created() {
        if (this.loggedIn) {
            console.log(this.loggedIn);
            this.$router.push("/dashboard");
        }
        //code in case of sso login start
        if (this.$route.query && this.$route.query.ssoToken) {
            let encryptedData = JSON.parse(CryptoJS.AES.decrypt(this.$route.query.ssoToken, "jhfwfqwyf8qwfoiqwfoqwuq").toString(CryptoJS.enc.Utf8));
            let userInfo = encryptedData.userData;
            localStorage.setItem('user', JSON.stringify({ token: userInfo.token, id: userInfo.id, user: userInfo.display_username, organization_id: userInfo.organization_id, hotspot_id: userInfo.hotspot_id }));
            this.$store.dispatch('auth/login', { token: userInfo.token, id: userInfo.id, user: userInfo.display_username, organization_id: userInfo.organization_id, hotspot_id: userInfo.hotspot_id });

        }
        //code in case of sso login end
    },
    methods: {
        onSubmit() {

            if (!this.form) {
                return
            }
            else {
                try {
                    this.form_data.encryptedHotspotId=localStorage.getItem('encodedHotspotId');
                    this.$store.dispatch('theme/updateIsLoading', true);
                    AuthService.login(this.form_data)
                        .then(response => {
                            console.log(response)
                            this.$store.dispatch('auth/login', response);
                            this.$store.dispatch('theme/updateIsLoading', false);
                            this.$router.push("/dashboard");
                        })
                        .catch(e => {
                            this.$SweetToast.error(e.response.data.message);
                            this.$store.dispatch('theme/updateIsLoading', false);
                        });
                } catch (err) {
                    this.$store.dispatch('theme/updateIsLoading', false);
                    console.log(err);
                }
            }
            this.loading = true

            setTimeout(() => (this.loading = false), 2000)
        },
        required(v) {
            return !!v || 'Field is required'
        },
    },
}
</script>
  
  